<div class="setApiPass-main-container">
  <div class="setApiPass-container">
    <p class="setApiPass-container__desc">Define API password</p>
    <form
      [formGroup]="form"
      (ngSubmit)="changePass()"
      fxLayout="column"
      fxLayoutAlign="center"
    >
      <aran-input
        type="password"
        placeholder="Enter user password"
        label="User Password"
        formControlName="userPassword"
        [obscure]="true"
        [errorMessages]="{
          required: errorMessages.required('User Password'),
        }"
        (enterPressed)="onEnterPressed()"
      ></aran-input>

      <app-input-psw-criteria
        type="password"
        placeholder="Enter API password"
        label="API Password"
        formControlName="apiPassword"
        [obscure]="true"
        [criteriaList]="criteriaList"
        [errorMessages]="{
          required: errorMessages.required('API Password'),
          minlength: errorMessages.minlength(8),
          ascii: errorMessages.ascii,
          weak: errorMessages.weak
        }"
        (enterPressed)="onEnterPressed()"
      >
      </app-input-psw-criteria>

      <aran-input
        type="password"
        placeholder="Confirm API password"
        label="Confirm API Password"
        formControlName="confirmApiPassword"
        [obscure]="true"
        [errorMessages]="{
          required: errorMessages.required('Confirm API Password'),
          passwordMismatch: errorMessages.notMatch
        }"
        (enterPressed)="onEnterPressed()"
      ></aran-input>

      <div class="mt-5">
        <aran-button
          class="w-full"
          [type]="'submit'"
          [name]="'Confirm'"
          [disabled]="!form.valid"
          [className]="!form.valid ? 'btn_disabled' : ''"
        ></aran-button>
      </div>
    </form>
  </div>
</div>
